import API from 'shared/lib/api'

import { extend, merge } from 'lodash'

export default {
  // Update resource on the API.
  //
  // @example
  //   SomeModel.actions.update({id: 1, attributes: { name: 'some name' }, optimistic: true})
  //
  actionMethod (model, options = {}) {
    options = merge({}, options)
    options[model.singularName] = options.attributes
    options.apiVersion = options.apiVersion ?? model.options.apiVersion

    return API.updateResource(model.pluralName, options.id, options)
  },

  // Updates record (optimistically) in the collection.
  //
  reduceMethod (model, collection, action) {
    const options = action?.payload?.options || {}
    const id = options.id

    switch (action.type) {
      case 'ORM_RESET_RECORD': {
        // Resets record state by resetting the async state values
        const record = action?.payload?.record

        if (record && model === record.constructor) {
          collection = collection.update(record.id, model._asyncDefaultValues)
        }

        return collection
      }

      case model.actionTypes.UPDATE_START:
        if (id) {
          // Set update flags
          const attributes = { isBusy: true, pendingUpdate: true }

          // Optimistic update record with new attributes
          if (options.optimistic && options.attributes) {
            // Store original values before optimistic update for potential reversion
            const currentRecord = collection.getById(id)
            if (currentRecord) {
              const originalValues = {}
              Object.keys(options.attributes).forEach((key) => {
                originalValues[key] = currentRecord[key]
              })
              attributes._optimisticOriginalValues = originalValues
            }

            extend(attributes, options.attributes)
          }

          collection = collection.update(id, attributes)
        }

        return collection

      case model.actionTypes.UPDATE_ERROR:
        if (id) {
          const currentRecord = collection.getById(id)
          const errorAttributes = {
            isBusy: false,
            pendingUpdate: true,
            hasError: true,
            errorData: action?.payload?.error
          }

          if (options.optimistic && currentRecord && currentRecord._optimisticOriginalValues) {
            // Revert optimistic changes by restoring original values
            extend(errorAttributes, currentRecord._optimisticOriginalValues)
            // Clear the stored original values
            errorAttributes._optimisticOriginalValues = undefined
          }

          // Set error flag and revert optimistic changes if applicable
          collection = collection.update(id, errorAttributes)
        }

        return collection

      case model.actionTypes.UPDATE_SUCCESS:
        if (id) {
          // Remove update flags and clear any stored original values
          collection = collection.update(options.id, {
            isBusy: false,
            pendingUpdate: false,
            _optimisticOriginalValues: undefined
          })
        }

        return collection
    }
  }
}
